import React, {MouseEvent} from "react";
import {observer} from "mobx-react";
import {InputContainerComponent} from "./input-container/input-container.component";
import {FieldInputContainerComponentProps, InputContainerComponentProps} from "./inputs-common.props";

export const FieldInputContainerComponent: React.FC<FieldInputContainerComponentProps> = observer(props => {

    if(props.field.isHidden) {
        return null;
    }

    const captureInputContainerElementRef = (element: HTMLDivElement) => {
        props.field.attachContainerDOMElement(element);
        if(props.captureInputContainerRef) {
            props.captureInputContainerRef(element);
        }
    }

    const renderLabel = () => {
        if(props.renderLabel) {
            const renderLabel = props.renderLabel;
            return () => renderLabel();
        }

        return () => props.field.fieldName;
    }

    const onClearButtonClick = (event: MouseEvent<HTMLDivElement>) => {
        if(props.onClearButtonClick) {
            props.onClearButtonClick(event);
        }

        if(event.isDefaultPrevented() || event.isPropagationStopped()) {
            return;
        }

        props.field.clear();
        props.field.setFocus({noScroll: true});
    }

    const inputContainerProps: InputContainerComponentProps = {
        ...props,
        captureInputContainerRef: captureInputContainerElementRef,
        renderLabel: renderLabel(),
        errorMessage: props.field.error,
        showClearButton: (props.showClearButton && Boolean(props.field.value)) || Boolean(props.forceClearButton),
        onClearButtonClick: onClearButtonClick,
        isReadonly: props.isReadonly || props.field.isReadOnly
    }

    return (
        <InputContainerComponent {...inputContainerProps}/>
    )
});
